import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useMemo } from "react";
import { mapPayoutBatchStatus } from "../mappers/payouts.mapper";
import type { BatchesFiltersType } from "../types/payouts.type";
import { useQuery } from "@tanstack/react-query";

export function useFetchPayoutBatches(
  filters: BatchesFiltersType = {},
  cursor?: string
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      id: filters.id && filters.id.trim() !== "" ? filters.id : undefined,
      createdAtRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      statuses:
        filters.status &&
        mapPayoutBatchStatus[
          filters.status as keyof typeof mapPayoutBatchStatus
        ]
          ? [
              mapPayoutBatchStatus[
                filters.status as keyof typeof mapPayoutBatchStatus
              ],
            ]
          : undefined,
      cursor,
    }),
    [merchant?.id, cursor, filters]
  );

  const { data, isLoading, refetch } = useQuery(
    trpc.payoutBatches.list.queryOptions(queryInput, {
      enabled: !!merchant?.id,
    })
  );

  const batches = data?.data || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = data?.length || 0;

  return {
    batches,
    nextCursor,
    totalItems,
    isLoading,
    refetch,
  };
}
